import { ISelectOption } from '@dss-libs/shared/type/common-types';

/**
 * Construct translated select options with value as the enum key and label as the translated value
 * @param enumObj - The enum to be translated
 * @param mapper - The translation mapper which maps enum keys to translation keys
 * @param excludedKeys - Keys to be excluded from the select options
 * @returns ISelectOption[]
 */
export const constructTranslatedSelectOptionsUtility = (
  enumObj: { [key: string | number]: string },
  mapper: Map<any, string>,
  excludedKeys: (string | number)[] = []
): ISelectOption[] => {
  const selectOptions: ISelectOption[] = [];
  Object.keys(enumObj).forEach((key) => {
    if (!excludedKeys.includes(key)) {
      selectOptions.push({
        label: mapper.get(key) || '',
        value: enumObj[key],
      });
    }
  });
  return selectOptions;
};
